import Plugin from '@quasar/quasar-ui-qflashcard';
import '@quasar/quasar-ui-qflashcard/dist/index.css';

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async ({ Vue }) => {
  Vue.use(Plugin);
};
